import classNames from 'classnames';
import React, { FC, LabelHTMLAttributes } from 'react';
import styles from './SelectableToggleBox.module.scss';

type SelectableToggleBoxLabelProps = LabelHTMLAttributes<HTMLLabelElement> & {};

export const SelectableToggleBoxLabel: FC<SelectableToggleBoxLabelProps> = ({ children, ...props }) => {
	return (
		<label {...props} className={classNames(styles.selectableToggleBoxLabel, 'link-mask')}>
			{children}
		</label>
	);
};
